export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 rounded-3xl overflow-hidden relative">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20geometric%20pattern%20with%20flowing%20waves%20and%20dots%20in%20warm%20coral%20tones%2C%20modern%20tech%20background%2C%20clean%20minimal%20design%2C%20soft%20gradient%20texture%2C%20no%20text%20no%20letters&width=1200&height=600&seq=app-bg-51bl&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>

          <div className="relative flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
                随时随地，吃瓜不等待
              </h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
                51爆料移动端即将上线！支持推送通知，热点爆料第一时间送达。支持离线浏览，地铁上也能安心吃瓜。
                关注公众号抢先体验内测资格。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-700 font-semibold rounded-full text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-smartphone-line text-lg"></i>
                  即将上线
                </div>
                <div className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 text-background-50 border border-background-50/25 font-medium rounded-full text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-colors">
                  <i className="ri-wechat-line text-lg"></i>
                  关注公众号
                </div>
              </div>
            </div>
            <div className="flex-shrink-0 w-48 md:w-56">
              <div className="aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/20">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20stylized%20modern%20mobile%20app%20screen%20mockup%20showing%20a%20news%20feed%20interface%20with%20warm%20coral%20and%20cream%20color%20scheme%2C%20clean%20UI%20design%2C%20card%20based%20layout%2C%20elegant%20typography%2C%20editorial%20news%20app%20aesthetic%2C%20no%20text%20no%20letters&width=400&height=700&seq=app-mock-51bl&orientation=portrait"
                  alt="51爆料移动端界面预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}